import Vue from 'vue'
import Vuex from 'vuex'
import "@/types"

import auth from './auth'
import views from './views'

Vue.use(Vuex)

const _user:User = {
  email: null,
  id: null,
  name: null
}

export default new Vuex.Store({

  state: {
    user: _user,
    client: {},
    partner: {},
    schemas: {},
    viewsDisplay: 'list',
  } as {[key:string]: any},

  mutations: {
    setClient(state, client) {
      state.client = client
    },
    setItems(state, {collection, items}) {
      state[collection] = items
    },
    setSchemas (state, schemas) {
      state.schemas = schemas
    },
    setUser (state, user) {
      user ? state.user = user : state.user = _user
    },
    setViewsDisplay: (state, display) => {
      state.viewsDisplay = display
    },
  },

  actions: {
    setClient({commit}, client) {
      commit('setClient', client)
    },
    setSchemas({ commit }, schemas) {
      commit('setSchemas', schemas)
    },
    updateUser({ commit }, user) {
      commit('setUser', user)
    }
  },
  
  getters: {
    user({ user }) {
      const { id, name, email } = user
      return { id, name, email }
    }
  },

  modules: {
    auth, views
  }
})
